/** `/c/$companyId/reports/trial-balance?from&to&compare&hideZero` — Back keeps the filters. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { COMPARISONS } from "../reports/range";
import { TrialBalanceScreen } from "../reports/TrialBalanceScreen";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const search = z.object({
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
  compare: z.enum(COMPARISONS).catch("none"),
  hideZero: z.boolean().catch(true),
});

export const Route = createFileRoute("/_auth/c/$companyId/reports/trial-balance")({
  validateSearch: (raw) => search.parse(raw),
  component: TrialBalance,
});

function TrialBalance(): JSX.Element {
  const { companyId } = Route.useParams();
  const current = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <TrialBalanceScreen
      companyId={companyId}
      search={current}
      onSearch={(changes) => void navigate({ search: { ...current, ...changes } })}
    />
  );
}
